import i18n from '../locales/index'
import Vuex from "vuex"
import Vue from 'vue'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        count: 0,
        userAdd: null,
        productInfo: null,
        userInfo: {
            level: 0,
            referrer: '',
            lastClaimTime: 0,
            lastSZCClaimTime: 0,
            totalEarnings: '0',
            pendingEarnings: '0',
            lastWithdrawalTime: 0,
            directReferralCount: 0,
            totalReferralEarnings: '0',
            totalSalesAmount: '0',
            pendingSZCRewards: '0',
            totalSZCRewards: '0',
            purchasedProductId: '',
            productData: {} // 存储产品相关数据
        }
    },
    mutations: {
        increment (state ) {
            state.count++
        },
        updateUserAdd(state, address) {
            state.userAdd = address;
        },
        updateProductInfo(state, info) {
            state.productInfo = info;
        },
        UPDATE_USER_INFO(state, userInfo) {
            state.userInfo = {
                ...state.userInfo,
                ...userInfo
            };
        }
    },
      actions: {
        updateUserAdd({ commit }, address) {
          commit('updateUserAdd', address);
        },
        updateProductInfo({ commit }, info) {
            commit('updateProductInfo', info);
        },
        updateUserInfo({ commit }, userInfo) {
            commit('UPDATE_USER_INFO', userInfo);
        }
      }
})
export default store;